import React from 'react'
import PageHeader from '../../../components/PageHeader'
import { Tag, Tooltip } from 'antd';
import Certificates from './Certificates';

const Achievements = () => {
    return (
        <div className="flex flex-col gap-8">

            <div className="flex flex-col gap-4">
                <PageHeader title={"Badges You Deserves"} />
                <BatchesList />
            </div>
            <div className="flex flex-col gap-4">
                <PageHeader title={"Certificates"} />
                <Certificates />
            </div>
        </div>

    )
}

export default Achievements;

const batches = [
    {
        name: 'Feature/Enhancement',
        color: '#87d068',
        tooltip: 'Enhancements to the existing features',
    },
    {
        name: 'Bug Fixes',
        color: '#f50',
        tooltip: 'Fixes for reported bugs',
    },
    {
        name: 'Documentation',
        color: '#2db7f5',
        tooltip: 'Updates to project documentation',
    },
    {
        name: 'Testing',
        color: '#108ee9',
        tooltip: 'Improvements or additions to tests',
    },
    {
        name: 'Refactoring',
        color: '#722ed1',
        tooltip: 'Code restructuring without functional changes',
    },
];

const BatchesList = () => {
    return (
        <div className="flex flex-wrap gap-3">
            {batches.map((batch, index) => (
                <Tooltip key={index} title={batch.tooltip} className='flex flex-col items-center' >
                    <img className='w-40 h-40' src="https://juststickers.in/wp-content/uploads/2016/11/i-am-a-code-blooded-developer-badge.png" alt="" />
                </Tooltip>
            ))}
        </div>
    );
};
